'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Arrow = function Arrow(options) {
  var ARROW_MAP = {
    down: '\'\\f0d7\'',
    up: '\'\\f0d8\'',
    right: '\'\\f0da\'',
    left: '\'\\f0d9\''
  };
  var defaults = {
    arrow: 'down',
    position: 'before',
    color: 'inherit',
    size: '20px'
  };
  var settings = _extends({}, defaults, options);

  return '\n    &::' + settings.position + ' {\n      color: ' + settings.color + ';\n      content: ' + ARROW_MAP[settings.arrow] + ';\n      font-family: \'Font Awesome 5 Free\';\n      font-size: ' + settings.size + ';\n      font-weight: 900;\n      font-style: normal;\n    }\n  ';
};

exports.default = Arrow;